import salesforceCrmReadmeMarkdown from '@/assets/Artifacts/README.md?raw'
import {
  CRM_PROJECT_ROOT,
  SALESFORCE_AUTH_CALLBACK_URL,
  writeStep,
} from './zohoCrmIntegrationDemoContent.part01.js'
import { buildStepNarration } from './stepNarrationCopy.js'

export const ZOHO_CRM_INTEGRATION_AI_LOG_STEPS_BUILD = [
  writeStep(
    'app/core/config.py',
    `from pydantic_settings import BaseSettings
from functools import lru_cache

class Settings(BaseSettings):
    SALESFORCE_CLIENT_ID: str
    SALESFORCE_CLIENT_SECRET: str
    SALESFORCE_REDIRECT_URI: str = "${SALESFORCE_AUTH_CALLBACK_URL}"
    SALESFORCE_API_BASE_URL: str = "https://login.salesforce.com"
    API_PREFIX: str = "/api/v1"

@lru_cache()
def get_settings() -> Settings:
    return Settings()`,
    2800,
    undefined,
    'app/core/salesforce_client.py',
    0,
  ),
  writeStep(
    'app/core/salesforce_client.py',
    `"""Salesforce CRM OAuth2 client with automatic token refresh."""
import httpx
from app.core.config import get_settings

class SalesforceClient:
    async def exchange_code(self, code: str) -> dict: ...
    async def get(self, path: str, params=None): ...
    async def post(self, path: str, body: dict): ...

salesforce_client = SalesforceClient()`,
    2800,
    undefined,
    'app/schemas/lead.py',
    1,
  ),
  writeStep('app/schemas/lead.py', 'LeadCreateRequest, ContactCreateRequest, SalesforceRecordResponse', 2800, undefined, 'app/schemas/opportunity.py', 2),
  writeStep('app/schemas/opportunity.py', 'OpportunityCreateRequest, OpportunityUpdateRequest, OrderLineItem, OpportunityResponse', 2800, undefined, 'app/schemas/product.py', 3),
  writeStep('app/schemas/product.py', 'ProductUpsertRequest, ProductBulkSyncRequest, ProductResponse', 2800, undefined, 'app/schemas/webhook.py', 4),
  writeStep('app/schemas/webhook.py', 'SalesforceWebhookEvent, WebhookAckResponse', 2800, undefined, 'app/services/lead_service.py', 5),
  writeStep('app/services/lead_service.py', 'create_lead, create_or_update_contact, get_leads, convert_lead', 2800, undefined, 'app/services/opportunity_service.py', 6),
  writeStep('app/services/opportunity_service.py', 'create_opportunity, update_opportunity, get_opportunity — line-item amount calculation', 2800, undefined, 'app/services/product_service.py', 7),
  writeStep('app/services/product_service.py', 'upsert_product, bulk_sync (200/call), list_products', 2800, undefined, 'app/services/webhook_service.py', 8),
  writeStep('app/services/webhook_service.py', 'process inbound Salesforce Platform Event notifications', 2800, undefined, 'app/api/salesforce_router.py', 9),
  writeStep(
    'app/api/salesforce_router.py',
    `router = APIRouter(prefix="/salesforce", tags=["Salesforce CRM"])
# /auth, /leads, /contacts, /opportunities, /products, /webhook`,
    3200,
    undefined,
    'app/main.py',
    10,
  ),
  writeStep(
    'app/main.py',
    `app = FastAPI(title="Website ↔ Salesforce CRM Integration API")
app.include_router(salesforce_router, prefix="/api/v1")`,
    2800,
    buildStepNarration('The FastAPI app entrypoint is wired', 'adding unit and integration tests', 2),
    'tests/test_lead_service.py',
    11,
  ),
  writeStep('tests/test_lead_service.py', 'Unit tests for lead field mapping (mocked Salesforce API)', 2800, undefined, 'tests/test_opportunity_service.py', 12),
  writeStep('tests/test_opportunity_service.py', 'Unit tests for opportunity amount calculation', 2800, undefined, 'tests/test_product_service.py', 13),
  writeStep('tests/test_product_service.py', 'Unit tests for bulk sync batching', 2800, undefined, 'tests/test_api.py', 14),
  writeStep('tests/test_api.py', 'TestClient integration tests for /health and /leads', 2800, undefined, '.env.example', 15),
  writeStep('.env.example', 'SALESFORCE_CLIENT_ID, SALESFORCE_CLIENT_SECRET, SALESFORCE_REDIRECT_URI', 2800, undefined, 'requirements.txt', 16),
  writeStep('requirements.txt', 'fastapi, uvicorn, httpx, pydantic, pydantic-settings, pytest', 2800, undefined, 'README.md', 17),
  {
    durationMs: 36000,
    actionName: 'Wrote file',
    arguments: {
      op: 'write',
      path: `${CRM_PROJECT_ROOT}/README.md`,
      content: salesforceCrmReadmeMarkdown,
    },
    result: { ok: true },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'The README with setup and endpoint docs is written',
      'loading the rename chat tool',
      3,
    ),
  },
  {
    durationMs: 1200,
    actionName: 'Loaded rename_chat',
    arguments: { tools: [{ toolName: 'rename_chat' }] },
    result: { status: 'loaded', tools: [{ connectionId: null, toolName: 'rename_chat' }] },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'Rename chat is loaded',
      'titling this thread Salesforce CRM Integration API',
      4,
    ),
  },
  {
    durationMs: 400,
    actionName: 'Chat renamed.',
    arguments: {
      toolName: 'rename_chat',
      args: { new_title: 'Salesforce CRM Integration API' },
    },
    result: { message: 'Chat renamed to: "Salesforce CRM Integration API"' },
    status: 'ok',
    defaultExpanded: false,
    stepNarration: buildStepNarration(
      'This chat is now titled Salesforce CRM Integration API',
      'summarizing what was built',
      0,
    ),
  },
]
